import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
const Login = () => {
  const { loginWithRedirect } = useAuth0();

  return (
    <div>
      <div className="card card-authentication1 mx-auto my-5 animated bounceInDown">
        <div className="user-lock rounded-top bg-primary">
          <div className="user-lock-img">
            <img src={process.env.PUBLIC_URL + "assets/images/logo.png"} />
          </div>
        </div>
        <div className="card-body">
          <h4 className="text-center my-5 py-2">Welcome to Vengage</h4>
          <hr />
          <h6>
            Welcome to Vengage operator dashboard. You can connect to a customer
            using the dashboard. In case you do not have a login please write to
            help@vengage.ai
          </h6>
        </div>
        <div className="form-footer mt-2" align="center">
          <a
            href="javascript:"
            onClick={() => loginWithRedirect()}
            className="btn btn-primary btn-block login-btn loginbtn"
          >
            <i className="fa fa-sign-in"></i>Login
          </a>
        </div>
      </div>
    </div>
  );
};

export default Login;
